<template>
    <div class="page-warpper home">
        <videoPlayer> </videoPlayer>
        <div class="part-panel part-special" data-index='intro'>
            <div class="part-body self-bg">
                <img src="../assets/images/index/cnt-intro.png" alt="">
            </div>
        </div>
        <!-- <div class="part-panel" data-index='pro'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <img src="../assets/images/index/cnt-pro.png" alt="">
            </div>
        </div> -->
        <div class="part-panel part-special" data-index='sign'>
            <h1 class="part-title"></h1>
            <div class="part-body "  v-bind:class="[ tabIdx == 'yc'? 'tab-signYc' : 'tab-signFc']">
                <!-- <img src="../assets/images/index/sign-step.png" alt=""> -->
                <div class='self-bg'></div>
                <div class='part-tab'>
                    <span class='tab-item'  v-bind:class="{select: tabIdx == 'yc'}"  v-on:click="tabIdx = 'yc'">原创报名</span>
                    <span class='tab-item tab-fc' v-bind:class="{select: tabIdx == 'fc'}"  v-on:click="tabIdx = 'fc'">翻唱报名</span>
                </div>
                <div class='tab-body tab-body-yc'>
                    <ul  class='part-txt'>
                        <li>
                            <span  class='num'></span>
                            <span class='txt'>录制参赛歌曲→ 登录5sing个人主页→ 点击上传歌曲→填好歌曲相关信息。 </span>
                        </li>
                        <li>
                            <span  class='num'></span>
                            <span  class='txt'>复制作品链接至本活动页面，点击报名按钮→  按弹窗要求填写个人信息→发布微博加标签TAG #国漫音乐大赛#并@腾讯动漫@国漫演唱会@原创音乐基地→ 参赛成功。</span>
                        </li>
                        <li>
                            <span  class='num'></span>
                            <span  class='txt'>参赛作品需为腾讯动漫的动画作品创作原创歌曲或大赛指定翻唱歌曲，并由本人亲自创作或演唱，上传不合规定的作品视为无效。</span>
                        </li>
                        <li class='key-txt'>
                            <span class='num'></span>
                            <span class='txt'>同人原创音乐大赛需围绕以下作品进行创作： 狐妖小红娘、一人之下、灵契、从前有座灵剑山、妖怪名单、尸兄（我叫白小飞）、勇者大冒险、超游世界、东郭小节、幻界王、降灵记、戒魔人、君临臣下、麻神、生死回放、时光诡域、时空使徒、双生灵探、通职者、王牌御史、我的逆天神器、我的天劫女友、血色苍穹、银之守墓人、天才玩偶、山河社稷图、猫妖的诱惑、秦侠、小绿和小蓝、通灵妃</span>
                        </li>
                        <li class='key-txt'>
                            <span  class='num'></span>
                            <span  class='txt'>同人原创作品的作曲、编曲、作词等都为参赛人或团队自主原创，不得使用已有作品或他人作品的曲子进行填词，如发现盗取、侵权等不实行为，将被直接取消比赛资格。</span>
                        </li>
                        <li>
                            <span  class='num'></span>
                            <span  class='txt'>为避免比赛中产生不必要的质疑和纠纷。请所有参赛选手保留比赛歌曲的干声。</span>
                        </li>
                        <li>
                            <span  class='num'></span>
                            <span  class='txt'>参赛曲目作品命名须统一前缀【国漫音乐大赛原创】+歌曲名。</span>
                        </li>
                    </ul>
                    <signTabYc ></signTabYc>
                </div>
                <div class='tab-body tab-body-fc'>
                    <ul  class='part-txt'>
                        <li>
                            <span  class='num'></span>
                            <span  class='txt'>下载待翻唱歌曲伴奏→录制参赛歌曲→ 登录5sing个人主页→ 点击上传歌曲→填好歌曲相关信息。</span>
                        </li>
                        <li>
                            <span  class='num'></span>
                            <span class='txt'>复制作品链接至本活动页面，点击报名按钮→  按弹窗要求填写个人信息→发布微博加标签TAG #国漫音乐大赛# 并@腾讯动漫@国漫演唱会@原创音乐基地→ 参赛成功。</span>
                        </li>
                        <li>
                            <span  class='num'></span>
                            <span  class='txt'>参赛作品需为腾讯动漫的动画作品创作原创歌曲或大赛指定翻唱歌曲，并由本人亲自创作或演唱，上传不合规定的作品视为无效。</span>
                        </li>
                        <li class='key-txt'>
                            <span  class='num'></span>
                            <span  class='txt'> 翻唱作品选择演唱官方指定歌单曲目，上传作品到活动页面（请使用本活动页面所提供的歌曲伴奏，演唱方式不作要求，旋律及编曲等可进行一定程度改编，但不接受重新填词）。</span>
                        </li>
                        <li><span  class='num'></span>为避免比赛中产生不必要的质疑和纠纷。请所有参赛选手保留比赛歌曲的干声。</li>
                        <li><span  class='num'></span>参赛曲目作品命名须统一前缀 【国漫音乐大赛翻唱】+歌曲名。</li>
                    </ul>
                    <img  class='download-head' src="../assets/images/index/sign-t.png" alt="">
                    <ul class="download-panel">
                        <li v-for="item in bzData">
                            <p class="song-name">{{item.name}}</p>
                            <a class="download-link yq-download-link"  v-bind:href="item.ycurl" target="_blank" >原曲</a>     
                            <a class="download-link bz-download-link" v-bind:href="item.bzurl"  target="_blank" >伴奏</a>                                                
                        </li>
                    </ul>
                    <signTabFc ></signTabFc>
                </div>
            </div>
        </div>
        <div class="part-panel part-special" data-index='songTop15'>
            <h1 class="part-title"></h1>
            <div class="part-body self-bg">
                <workTop  :wType="3"></workTop> 
            </div>
        </div>


        <div class="part-panel" data-index='activityRim'>
            <div  class="part-warpper" data-index='weibo'>
                <h1 class="part-title"></h1>
                <div class="part-body">
                    <iframe src="http://widget.weibo.com/topics/topic_vote_base.php?border=0&amp;footbar=1&amp;width=560&amp;height=599&amp;refer=1&amp;filter=0&amp;language=zh_cn&amp;version=base&amp;dup=0&amp;antispam=0&amp;isOutTopicSearch=2&amp;top_mblog=z8ClGsZa8&amp;isshowright=0&amp;tag=%25E5%259B%25BD%25E6%25BC%25AB%25E9%259F%25B3%25E4%25B9%2590%25E5%25A4%25A7%25E8%25B5%259B&amp;og=http%3A%2F%2F5sing.kugou.com%2Fsubject%2Ftgm%2Findex&amp;r=1535373084998" width="560" height="1190" frameborder="0" scrolling="no" marginheight="0"></iframe>
                </div>
            </div>
            <div  class="part-warpper" data-index='sponsor'>
                <div data-index='1'>
                    <h1 class="part-title"></h1>
                    <div class="part-body">
                        <a class="part-item md" href="http://ac.qq.com/"   target="_blank"></a>
                        <a class="part-item mg" href="javascript:void(0);" ></a>
                        <a class="part-item sing" href="http://5sing.kugou.com/index.html"   target="_blank"></a>
                        <a class="part-item kugou" href="http://www.kugou.com/"   target="_blank"></a>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import videoPlayer from '@/components/video-players'
import signTabYc from '@/components/sign-tab'
import signTabFc from '@/components/sign-tab-fc'
import workTop from '@/components/work-top'
export default {
    name: 'indexHome',
    data () {
        return {
            msg: 'Welcome to Your Vue.js App',
            tabIdx: 'yc',
            bzData: [
                {
                    "name":"无涯",
                    "ycurl":"http://5sing.kugou.com/yc/3690711.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070293.html"
                },
                {
                    "name":"听风吟",
                    "ycurl":"http://5sing.kugou.com/yc/3690703.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070292.html"
                },
                {
                    "name":"丹歌惊鸿",
                    "ycurl":"http://5sing.kugou.com/yc/3688757.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069566.html"
                },
                {
                    "name":"念斗章",
                    "ycurl":"http://5sing.kugou.com/yc/3688777.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069569.html"
                },
                {
                    "name":"幺妹冯宝宝",
                    "ycurl":"http://5sing.kugou.com/yc/3690729.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070295.html"
                },
                {
                    "name":"游龙",
                    "ycurl":"http://5sing.kugou.com/yc/3688774.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069568.html"
                },
                {
                    "name":"梦回还",
                    "ycurl":"http://5sing.kugou.com/yc/3688665.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069529.html"
                },
                {
                    "name":"相聚万年树",
                    "ycurl":"http://5sing.kugou.com/yc/3688842.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070289.html"
                },
                {
                    "name":"若当来世",
                    "ycurl":"http://5sing.kugou.com/yc/3688686.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069527.html"
                },
                {
                    "name":"东流",
                    "ycurl":"http://5sing.kugou.com/yc/3690690.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069621.html"
                },
                {
                    "name":"铭记",
                    "ycurl":"http://5sing.kugou.com/yc/3690659.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070286.html"
                },
                {
                    "name":"万水依山",
                    "ycurl":"http://5sing.kugou.com/yc/3688741.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069549.html"
                },
                {
                    "name":"愿我",
                    "ycurl":"http://5sing.kugou.com/yc/3688781.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069573.html"
                },
                {
                    "name":"此彼绘卷",
                    "ycurl":"http://5sing.kugou.com/yc/3691122.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070462.html"
                },
                {
                    "name":"相遇论",
                    "ycurl":"http://5sing.kugou.com/yc/3691022.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070437.html"
                },
                {
                    "name":"夏日未命名",
                    "ycurl":"http://5sing.kugou.com/yc/3691028.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070440.html"
                },
                {
                    "name":"s&silence",
                    "ycurl":"http://5sing.kugou.com/yc/3688892.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069593.html"
                },
                {
                    "name":"好在你没离开",
                    "ycurl":"http://5sing.kugou.com/yc/3690805.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070305.html"
                },
                {
                    "name":"倒影",
                    "ycurl":"http://5sing.kugou.com/yc/3688800.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070303.html"
                },
                {
                    "name":"无限大",
                    "ycurl":"http://5sing.kugou.com/yc/3690807.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070306.html"
                },
                {
                    "name":"夕山谣",
                    "ycurl":"http://5sing.kugou.com/yc/3688957.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069604.html"
                },
                {
                    "name":"剑指苍茫",
                    "ycurl":"http://5sing.kugou.com/yc/3688942.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069600.html"
                },
                {
                    "name":"绯",
                    "ycurl":"http://5sing.kugou.com/yc/3690796.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070304.html"
                },
                {
                    "name":"不负",
                    "ycurl":"http://5sing.kugou.com/yc/3690762.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070301.html"
                },
                {
                    "name":"此时此世与你",
                    "ycurl":"http://5sing.kugou.com/yc/3690810.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070309.html"
                },
                {
                    "name":"逆天",
                    "ycurl":"http://5sing.kugou.com/yc/3690735.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070298.html"
                },
                {
                    "name":"the game",
                    "ycurl":"http://5sing.kugou.com/yc/3688859.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069582.html"
                },
                {
                    "name":"惊蛰",
                    "ycurl":"http://5sing.kugou.com/yc/3688832.html",
                    "bzurl":"http://5sing.kugou.com/bz/3069580.html"
                },
                {
                    "name":"Mandala Night",
                    "ycurl":"http://5sing.kugou.com/yc/3690697.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070288.html"
                },
                {
                    "name":"怜果",
                    "ycurl":"http://5sing.kugou.com/yc/3690628.html",
                    "bzurl":"http://5sing.kugou.com/bz/3070277.html"
                }
            ],
        }
    },
    components: {
        signTabYc,
        signTabFc,
        workTop,
        videoPlayer
    },
    created: function() {
        
    }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
$downloadColor: #acebfb;
.img-gap{
    margin:10px 0;
}
.swiper-container{
    height: 180px;
    .swiper-slide{
        img{
            width: 100%;
        }
    }
}
.part-panel[data-index="intro"]{
    // .part-title{
    //     background-image: url(componentsImgPath('index/title-intro.png'));
    // }
    margin-top: 50px;
    .part-body{
        font-size: 20px;
        text-align: center;
    }
}
.part-panel[data-index="pro"]{
    .part-title{
        background-image: url(componentsImgPath('index/title-pro.png'));
    }
    .part-body{
        text-align: center;
    }
}
.part-panel[data-index="sign"]{
    padding-bottom: 18px;
    background: url(componentsImgPath('index/sign-bg.png')) center 180px no-repeat,
                url(componentsImgPath('index/sign-bg1.png')) center bottom no-repeat;
    .part-title{
        margin-bottom: 80px;
        background-image: url(componentsImgPath('index/title-sign.png'));
    }
    .part-body{
        border: 1px solid #22def4;
        .part-tab{
            position: relative;
            height: 80px;
            line-height: 80px;
            font-size: 28px;
            cursor: pointer;
            border-top: 6px solid #4d7df0;
            border-bottom: 1px solid #22def4;
            background-color: #293058;
            .tab-item{
                position: absolute;
                display: inline-block;
                width: 49%;
                text-align: center;
            }
            .tab-fc{
                right: 0;
            }
            .select{
                height: 130px;
                line-height: 110px;
                top: -32px;
                font-size: 38px;
                background-image: url(componentsImgPath('index/sign-tabyc.png'));
            }
        }
        .tab-body{
            padding: 30px;
        }
    }
    .tab-signYc{
        .select{
            left: -1px;
            //background-image: url(componentsImgPath('index/sign-tabyc.png'));
        }
        .tab-body-yc{
            display: block;
        }
        .tab-body-fc{
            display: none;
        }
    }
    .tab-signFc{
        .select{
            right: -1px;
            //background-image: url(componentsImgPath('index/sign-tabfc.png'));
        }
        .tab-body-yc{
            display: none;
        }
        .tab-body-fc{
            display: block;
        }
    }
    .download-head{
        display: block;
        margin: 20px auto;
    }
    .download-panel{
        width: 1400px;
        li{
            display: inline-block;
            width:  489px;
            padding: 10px 0 10px 50px;
            margin: 20px 32px 0 0;
            border: 1px solid $downloadColor;
            background: url(componentsImgPath('index/song_1.png')) 3% center no-repeat;
        }
        .song-name{
            display: inline-block;
            width: 60%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            vertical-align: middle;
            color:  $downloadColor;
        }
        .download-link{
            display: inline-block;
            padding: 0 30px 0 15px;
            margin-right:  15px ;
            color: $downloadColor;
            background: url(componentsImgPath('index/song_2.png')) right center no-repeat;
        }
        .bz-download-link{
            border-left:1px solid  $downloadColor; 
        }
        .qc-download-link{
            padding:0 0 0 25px ;
            background-image: none;
            border-left:1px solid  $downloadColor; 
        }
    }
}
.part-panel[data-index="songTop15"]{
    //width: 1116px;
    .part-title{
        background-image: url(componentsImgPath('index/title-songtop.png'));
    }
    .part-body{
        margin-top: 40px;
    }
}

.part-panel[data-index="activityRim"]{
    vertical-align: top;
    font-size: 0;
    .part-warpper{
        display: inline-block;
        font-size: 0;
    }
    .part-warpper[data-index="weibo"]{
        width: 560px;
        .part-title{
            background-image: url(componentsImgPath('index/title-w.png'));
            background-position: top center;
        }
        .part-body{
            overflow: auto;
            width: 100%;
            height: 500px;
            overflow-x: hidden;
            background: #fff;
            border:1px solid #163b4d;
        }
    }
    .part-warpper[data-index="sponsor"]{
        width: 640px;
        vertical-align: top;
        div[data-index="1"]{
            .part-title{
                background-image: url(componentsImgPath('index/title-s.png'));
            }
            .part-item {
                display: block;
                margin: 50px auto;
            }
            .md{
                margin-top: 90px;
            }
            .sing,.mg{
                display: inline-block;
                margin : 20px ;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/index-home.vue